import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Loader, Pagination } from 'semantic-ui-react';

import { BATCH_SIZE } from '../../../helpers/newsUtils';
import { useNewsListingPagination } from '../../../helpers/useNewsListingPagination';
import NewsList from '../../News/NewsList';

const NewsListingTemplate = ({
  isEditMode,
  showSocialShare = true,
  content,
}) => {
  const folderContent = useSelector((state) => state.content.data);
  const listingContent = content || folderContent;
  const {
    items,
    loading,
    firstPage,
    activePage,
    fakeItemsLastRow,
    itemsTotal,
    totalPages,
    handlePaginationChange,
  } = useNewsListingPagination(listingContent);

  return (
    <div className="listing variation-noticies">
      {loading && (
        <div className="csj-page-loader">
          <Loader active inline="centered" />
        </div>
      )}
      <NewsList
        items={items}
        firstPage={firstPage}
        fakeItemsLastRow={fakeItemsLastRow}
        isEditMode={isEditMode}
        showSocialShare={showSocialShare}
        loading={loading}
      />
      {itemsTotal > BATCH_SIZE && (
        <div className="news-pagination-container">
          <Pagination
            key={totalPages}
            activePage={activePage}
            totalPages={totalPages}
            onPageChange={handlePaginationChange}
          />
        </div>
      )}
    </div>
  );
};

NewsListingTemplate.propTypes = {
  isEditMode: PropTypes.bool,
  showSocialShare: PropTypes.bool,
  content: PropTypes.objectOf(PropTypes.any),
};

NewsListingTemplate.defaultProps = {
  isEditMode: false,
  showSocialShare: true,
  content: null,
};

export default NewsListingTemplate;
